module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-1",
    attrs: {
      "id": "failureofjustice-kindleinterior-5-8-2016"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "tc-101"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "chapter-sub"
  }, [_c('span', {
    staticClass: "no-style-override2"
  }, [_vm._v("Other Exciting WildBlue Press Books by Jon Ferak")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-242-0-override2"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("DIXIE’S LAST STAND:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("Was It Murder Or Self-Defense?")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-242-0-override2"
  }, [_c('span', {
    staticClass: "no-style-override3"
  }, [_c('a', {
    attrs: {
      "href": "http://wbp.bz/dixie",
      "target": "_blank"
    }
  }, [_vm._v("http://wbp.bz/dixie")])]), _c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-242-0-override2"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal-242-0-override2"
  }, [_c('span', {
    staticClass: "no-style-override1"
  }, [_vm._v("BODY OF PROOF:")]), _vm._v(" "), _c('span', {
    staticClass: "no-style-override"
  }, [_vm._v("Tainted Evidence In The Murder Of Jessica O’Grady")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-242-0-override2"
  }, [_c('span', {
    staticClass: "no-style-override3"
  }, [_c('a', {
    attrs: {
      "href": "http://wbp.bz/bop",
      "target": "_blank"
    }
  }, [_vm._v("http://wbp.bz/bop")])]), _c('span', {
    staticClass: "no-style-override"
  }, [_c('br', {
    staticClass: "calibre1"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ecd1c16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0002.vue
// module id = 66
// module chunks = 0